import * as _ from 'underscore';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DatatableV3Component } from '../datatable-v3/datatable-v3.component';

@Component({
	selector: 'app-ctv-platform-performance-r3',
	styleUrls: ['./ctv-platform-performance-r3.component.css'],
	templateUrl: './ctv-platform-performance-r3.component.html'
})
export class CtvPlatformPerformanceR3Component extends DatatableV3Component implements OnInit, OnDestroy {
	@Input() iscustomendpoint: any;
	public platformAsc = false;
	public currentFieldName: string;
	public isPlatform = true;
	public newTableDataNetwork: any = {};
	public newTableDataPlatform: any = {};

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	ngAfterContentChecked(): void {
		this.newTableDataPlatform.data = this.dataTableObj.data.filter(
			(prop: { is_platform: string }) => prop.is_platform === 'true'
		);
		this.newTableDataNetwork.data = this.dataTableObj.data.filter(
			(prop: { is_platform: string }) => prop.is_platform === 'false'
		);
		this.newTableDataPlatform.columns = this.dataTableObj.columns;
	}

	impressionsComparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['impressions']) < parseFloat(d['impressions'])) {
			return 1;
		}
		if (parseFloat(c['impressions']) > parseFloat(d['impressions'])) {
			return -1;
		}
	}

	customSort(name: any): void {
		const data = JSON.parse(JSON.stringify(this.dataTableObj.data));
		const field_name = name.includes('%')
			? name.replace('%', '').split(' ')[0].toLowerCase() + '_completions_rate'
			: name.toLowerCase();
		if (this.currentFieldName === field_name) {
			this.dataTableObj.data = this.platformAsc ? _.sortBy(data, field_name).reverse() : _.sortBy(data, field_name);
			this.platformAsc = !this.platformAsc;
		} else {
			this.platformAsc = true;
			this.dataTableObj.data = _.sortBy(data, field_name);
			this.currentFieldName = field_name;
		}
	}

	percent25Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['25_completions_rate']) < parseFloat(d['25_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['25_completions_rate']) > parseFloat(d['25_completions_rate'])) {
			return -1;
		}
	}

	percent50Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['50_completions_rate']) < parseFloat(d['50_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['50_completions_rate']) > parseFloat(d['50_completions_rate'])) {
			return -1;
		}
	}

	percent75Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['75_completions_rate']) < parseFloat(d['75_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['75_completions_rate']) > parseFloat(d['75_completions_rate'])) {
			return -1;
		}
	}

	percent100Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['100_completions_rate']) < parseFloat(d['100_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['100_completions_rate']) > parseFloat(d['100_completions_rate'])) {
			return -1;
		}
	}

	platformComparator(a: any, b: any, c: any, d: any): number {
		if (c['platform_name'].toLowerCase() < d['platform_name'].toLowerCase()) {
			return -1;
		}
		if (c['platform_name'].toLowerCase() > d['platform_name'].toLowerCase()) {
			return 1;
		}
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.tableConfig.csvQueryKey ? this.tableConfig.csvQueryKey : this.key,
			this.tableConfig.downloadFileName
		);
	}

	toggleMode(): void {
		this.isPlatform = !this.isPlatform;
		if (this.isPlatform) {
			this.dataTableObj.columns[0].name = 'Platform';
			super.processDataForProgressBar(this.newTableDataPlatform.data);
		} else {
			this.dataTableObj.columns[0].name = 'Network';
			super.processDataForProgressBar(this.newTableDataNetwork.data);
		}
	}
}
